if (!window.ga11yMosaicReady) {
  window.ga11yMosaicReady = true;
(function(){
  var grid=document.querySelector('.whyx-mosaic-grid');
  var lb=document.querySelector('.whyx-lb');
  if(!grid||!lb) return;
  var img=lb.querySelector('img');
  var shots=[].slice.call(grid.querySelectorAll('.whyx-shot'));
  var i=0;
  function openAt(n){
    i=(n+shots.length)%shots.length;
    var b=shots[i];
    img.src=b.getAttribute('data-full');
    img.alt=b.getAttribute('aria-label')||'';
    lb.hidden=false;
    document.body.style.overflow='hidden';
  }
  function close(){ lb.hidden=true; document.body.style.overflow=''; }
  grid.addEventListener('click', function(e){
    var b=e.target.closest('.whyx-shot');
    if(!b) return;
    openAt(shots.indexOf(b));
  });
  lb.querySelector('.whyx-lb-x').addEventListener('click', close);
  lb.querySelector('.whyx-lb-prev').addEventListener('click', function(){ openAt(i-1); });
  lb.querySelector('.whyx-lb-next').addEventListener('click', function(){ openAt(i+1); });
  lb.addEventListener('click', function(e){ if(e.target===lb) close(); });
  document.addEventListener('keydown', function(e){
    if(lb.hidden) return;
    if(e.key==='Escape') close();
    if(e.key==='ArrowLeft') openAt(i-1);
    if(e.key==='ArrowRight') openAt(i+1);
  });
})();
(function(){
  var root=document.getElementById('wholesale-page'); if(!root) return;
  var grid=root.querySelector('.wsx-mosaic-grid');
  var lb=root.querySelector('.wsx-lb');
  if(!grid||!lb) return;
  var img=lb.querySelector('img');
  var shots=[].slice.call(grid.querySelectorAll('.wsx-shot'));
  var i=0;
  function openAt(n){
    i=(n+shots.length)%shots.length;
    var b=shots[i];
    img.src=b.getAttribute('data-full');
    lb.hidden=false;
    document.body.style.overflow='hidden';
  }
  function close(){ lb.hidden=true; document.body.style.overflow=''; }
  grid.addEventListener('click', function(e){
    var b=e.target.closest('.wsx-shot');
    if(!b) return;
    openAt(shots.indexOf(b));
  });
  lb.querySelector('.wsx-lb-x').addEventListener('click', close);
  lb.querySelector('.wsx-lb-prev').addEventListener('click', function(){ openAt(i-1); });
  lb.querySelector('.wsx-lb-next').addEventListener('click', function(){ openAt(i+1); });
  lb.addEventListener('click', function(e){ if(e.target===lb) close(); });
  document.addEventListener('keydown', function(e){
    if(lb.hidden) return;
    if(e.key==='Escape') close();
    if(e.key==='ArrowLeft') openAt(i-1);
    if(e.key==='ArrowRight') openAt(i+1);
  });
})();
}
